import React, { useEffect, useRef, useState, useMemo } from "react";
import styled from "styled-components";
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Row,
  Tooltip,
  Spin,
  Table,
  Badge,
} from "antd";
import { ReactComponent as ImportIcon } from "../../../assets/images/import.svg";
import FilterIcon from "../../../assets/images/Filter-Icon.svg";
// import { ReactComponent as FilterIcon } from "../../../assets/images/filter-svgrepo-com (1).svg";
import { ReactComponent as Indicator } from "../../../assets/images/Indicator.svg";
import { ReactComponent as Chat } from "../../../assets/images/Chat.svg";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import UIModal from "../../../Reusablecomponents/UIModal";
import ChatComponent from "../../../Reusablecomponents/Comment/ChatComponent";
import GridBuilder from "../../../UIBuilderEngine/GridBuilder";
import { CALL_API } from "../../../Common/api";
import { useSelector } from "react-redux";
import moment from "moment";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import { useLocation } from "react-router-dom";
import Cursor from "quill/blots/cursor";
import { convertUTCToLocal } from "../../../utils/helper";

const Wrappercontainer = styled.div`
  .customizable_container_forkpi {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
  .kpireport_select_filter {
    width: 290px !important;
    height: 34px;
  }
  p {
    padding: 10px 4px 10px 4px;
    margin: 4px 0px 4px 0px;
    font-size: 18px;
    font-weight: 400;
    color: black;
  }
  .kpialerts {
    color: rgb(228, 164, 0);
  }
  .Resolved {
    color: green;
  }
  .UnResolved {
    color: red;
  }
  .customizable_container {
    width: 30%;
    background-color: white;
    align-items: center;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    box-shadow:
      2px 2px 5px rgb(232, 235, 240),
      5px 5px 10px rgb(232, 235, 240),
      5px 5px 10px rgb(232, 235, 240);
  }
  .container_two_fordropdown {
    background-color: white;
    margin-top: 25px;
    border-radius: 12px;
    padding: 25px 0px 25px 0px;
  }
  .container_for_header {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 15px;
  }

  .resolve_btn:hover {
    background-color: green !important;
    color: white !important;
  }
  .ant-select-selector {
    border-radius: 18px;
  }
  .modal_container_forfiltermenu {
    display: flex;
    justify-content: space-between;
    margin: 7px 14px 07px 0px;
  }
  .flilter_five {
    margin: 0px;
  }
  .container_for_uimodaltwo {
    background-color: rgb(241, 241, 241);
    padding: 70px 70px 70px 70px;
    border-radius: 13px;
  }
  .cancel_btn_forpopup_two {
    background-color: rgb(232, 255, 236);
    color: green;
  }
  .ant-select-selector {
    border-radius: 18px;
  }
  .filterbtn {
    width: 45px;
    height: 42px;
    borderradius: 50%;
    border: 1px solid rgb(237, 237, 241);
    backgroundcolor: rgb(235, 247, 237);
  }
  .filterstyle {
    height: 20px;
    width: 20px;
  }
  .Iconbg {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: #ebf7ed;
  }
  .text-wrap {
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    line-height: 1.4;
  }
  .chat-box {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 10px;
    max-height: 300px;
    overflow-y: auto;
    padding-right: 10px;
  }

  .chat-message {
    background-color: #e5efff;
    border-radius: 12px;
    padding: 10px 14px;
    max-width: 75%;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  .chat-text {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
  }

  .chat-meta {
    font-size: 11px;
    color: #666;
    display: flex;
    justify-content: flex-start;
    gap: 6px;
  }

  .chat-sender {
    font-weight: 600;
  }

  .chat-time {
    font-style: italic;
  }
  .compact-col {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 150px;
    max-width: 180px;
    transition: max-width 0.2s ease;
  }

  .compact-col.expanded {
    justify-content: flex-start;
    max-width: 250px; /* only expand a little on hover */
  }
`;

const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    /* border-radius: 10px; */
    color: #5f6d8c;
    font-size: 14px;
    font-weight: 400;
  }
  .ant-table-row:nth-child(even) {
    background-color: #fafafa;
    width: 1108px;
  }
  .normal-column {
    min-width: 500px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: #363636;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .custom-row {
    height: 80px;
  }
`;

const Kpireport = () => {
  const location = useLocation();
  const { state } = location;
  const [form] = Form.useForm();
  const csvLinkEl = useRef();
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const [Hoveredrow, setHoveredRow] = useState(null);
  const [showModal, SetshowModal] = useState(false);
  const [resolveModal, setResolveModal] = useState(false);
  const [kpiReportData, setKpiReportData] = useState({});
  const [kpiReporttabledata, setKpiReporttabledata] = useState([]);
  const [filterCount, setFilterCount] = useState(0);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [commentsList, setCommentsList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [PageSize, setPageSize] = useState(10);

  const [filterData, setFilterData] = useState({
    duration: "current_month",
    Daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });
  const [formData, SetformData] = useState({
    Name: "",
    CustName: "",
    RecName: "",
    Transporter: "",
    Duration: "current_month",
    Consigncode: "",
    REGNO: "",
    DriverName: "",
    Status: "",
    ConsignId: "",
    Shipper: 0,
    code: "",
    Daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });
  const handlePageChange = (page, PageSize) => {
    setCurrentPage(page);
    setPageSize(PageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("KPIREPORT", "EX"),
    [reduxPermissions],
  );
  const resolveAllowed = useMemo(
    () => hasPermission("KPIREPORT", "BR"),
    [reduxPermissions],
  );
  const tableReqIdRef = useRef(0);
  const fetchReqIdRef = useRef(0);

  const kpifetchdata = async () => {
    setLoading(true);
    const reqId = ++fetchReqIdRef.current;
    try {
      const data = await CALL_API(
        "POST",
        `kpi/get_Kpialert?MCID=${userInfo?.MCID}&startDate=${dayjs(
          formData?.Daterange?.[0],
        )?.format("YYYY-MM-DD")}&endDate=${dayjs(
          formData?.Daterange?.[1],
        )?.format("YYYY-MM-DD")}`,
        {
          code: formData?.Consigncode || 0,
          RecName: formData?.Consignee || "",
          CustName: formData?.consignor || "",
          Transporter: formData?.Transporter || "",
          DriverName: formData?.Driver || "",
          Name: formData?.Kpiname || "",
          REGNO: formData?.Vehicle || "",
          Status: formData?.Status || "",
          ConsignId: formData?.ConsignId || "",
          Shipper: formData?.Shipper || 0,
        },
      );
      // ignore stale response
      if (reqId !== fetchReqIdRef.current) return;
      setKpiReportData(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching KPI summary:", error);
    }
  };
  const kpitabledata = async (page = 1, PageSize = 10) => {
    const reqId = ++tableReqIdRef.current;
    try {
      const { data } = await CALL_API(
        "POST",
        `kpi/get_Kpialert_Table?MCID=${userInfo?.MCID}&startDate=${dayjs(
          formData?.Daterange?.[0],
        )?.format("YYYY-MM-DD")}&endDate=${dayjs(
          formData?.Daterange?.[1],
        )?.format("YYYY-MM-DD")}&page=${page}&PageSize=${PageSize}`,
        {
          code: formData?.Consigncode || 0,
          RecName: formData?.Consignee || "",
          CustName: formData?.consignor || "",
          Transporter: formData?.Transporter || "",
          DriverName: formData?.Driver || "",
          Name: formData?.Kpiname || "",
          REGNO: formData?.Vehicle || "",
          Status: formData?.Status || "",
          ConsignId: formData?.ConsignId || "",
          Shipper: formData?.Shipper || 0,
        },
      );
      // ignore stale responses that arrived late
      if (reqId !== tableReqIdRef.current) return;
      setKpiReporttabledata(data?.KPIAlertTable || []);
      setTotal(data?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching KPI table data:", error);
      // keep previous table data on error; optionally message.error(...)
    }
  };
  const handleBulkResolve = async (records = []) => {
    try {
      const payload = {
        uid: userInfo?.UID,
        mcid: userInfo?.MCID,
      };
      setLoading(true);
      const { ResponseCode } = await CALL_API(
        "POST",
        "/kpi/bulkResolve",
        payload,
      );

      if (ResponseCode === 200) {
        message.success("KPIs resolved in bulk successfully!");
        setResolveModal(false);
        kpifetchdata();
        kpitabledata();
      }
    } catch (error) {
      console.error("Error resolving KPI:", error);
      message.error("An error occurred while resolving the KPI.");
    } finally {
      setLoading(false);
    }
  };
  const unresolvedKPIs = kpiReporttabledata?.filter((item) => !item.RESOLVEDBY);
  const handleResolve = async () => {
    try {
      if (!selectedRecord?.ID) {
        message.error("No KPI selected.");
        return;
      }
      const payload = {
        ID: selectedRecord.ID,
        MESSAGE: selectedRecord.resolutionComment || "",
        RESOLVEDBY: userInfo?.UID,
      };
      setLoading(true);
      const { data, ResponseCode } = await CALL_API(
        "POST",
        "kpi/resolve",
        payload,
      );
      if (ResponseCode === 200) {
        message.success(data?.data || "KPI resolved successfully!");
        setResolveModal(false);
        kpifetchdata();
        kpitabledata();
      }
    } catch (error) {
      console.error("Error resolving KPI:", error);
      message.error("An error occurred while resolving the KPI.");
    } finally {
      setLoading(false);
    }
  };
  const getCommentData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trip/getcommentTab`, {
      refTab: "KPI",
      refId: 389114,
    });
    setCommentsList(data);
    setLoading(false);
  };
  useEffect(() => {
    const t = setTimeout(() => {
      kpifetchdata();
    }, 240);
    return () => clearTimeout(t);
  }, [formData]);

  useEffect(() => {
    const t = setTimeout(() => {
      kpitabledata(currentPage, PageSize);
    }, 240);
    return () => clearTimeout(t);
  }, [formData, currentPage, PageSize]);

  const [modalType, setModalType] = useState(null); // "view" or "resolve"
  const [selectedRecord, setSelectedRecord] = useState(null);

  const handleresolveclose = () => {
    setResolveModal(false);
    setSelectedRecord(null);
    setModalType(null);
  };
  const handleChatClick = (record) => {
    setModalType("view"); // show resolved chat
    setSelectedRecord(record);
    setResolveModal(true);
    getCommentData(record); // pass record or ID to fetch
  };

  const handleresolveopen = (record) => {
    setModalType("resolve"); // show textarea to resolve
    setSelectedRecord(record);
    setResolveModal(true);
    getCommentData(record); // same here
  };

  const formattedTime = (totalMinutes) => {
    const hours = Math.floor(Math.abs(totalMinutes) / 60);
    const minutes = Math.abs(totalMinutes) % 60;

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  const formattedDifferentTime = (totalMinutes) => {
    const absMinutes = Math.abs(totalMinutes);
    const hours = Math.floor(absMinutes / 60);
    const minutes = absMinutes % 60;

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort.field];
      let bVal = b[tableSort.field];

      // Handle special case: status field (based on RESOLVEDBY)
      if (tableSort.field === "status") {
        const aResolved = a.RESOLVEDBY != null;
        const bResolved = b.RESOLVEDBY != null;
        const result = Number(aResolved) - Number(bResolved);
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle numeric fields
      if (
        ["MAXMINUTES", "DURATION", "MINMINUTES", "RESOLVEDBY"].includes(
          tableSort.field,
        )
      ) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };

  const columns = [
     {
        title: "Date & Time",
        dataIndex: "CRON",
        key: "CRON",
        sorter: (a, b) => (a.CRON || "").localeCompare(b.CRON || ""),
        sortOrder: tableSort.field === "CRON" ? tableSort.order : null,
        render: (_, record) => {
          return (<span>{convertUTCToLocal(record?.CRON)}</span>);
        }
      },
     {
      title: "Consign Code",
      dataIndex: "Code",
      key: "Code",
      sorter: (a, b) => (a.Code || "").localeCompare(b.Code || ""),
      sortOrder: tableSort.field === "Code" ? tableSort.order : null,
    },
    {
      title: "Consignee",
      dataIndex: "RecName",
      key: "RecName",
      ellipsis: false,
      sorter: (a, b) => (a.RecName || "").localeCompare(b.RecName || ""),
      sortOrder: tableSort.field === "RecName" ? tableSort.order : null,
      render: (text) => <div className="text-wrap">{text}</div>,
    },
    {
      title: "Consignor",
      dataIndex: "CustName",
      key: "CustName",
      ellipsis: false,
      sorter: (a, b) => (a.CustName || "").localeCompare(b.CustName || ""),
      sortOrder: tableSort.field === "CustName" ? tableSort.order : null,
      render: (text) => <div className="text-wrap">{text}</div>,
    },
    {
      title: "Transporter",
      dataIndex: "Transporter",
      key: "Transporter",
      ellipsis: false,
      sorter: (a, b) =>
        (a.Transporter || "").localeCompare(b.Transporter || ""),
      sortOrder: tableSort.field === "Transporter" ? tableSort.order : null,
      render: (text) => <div className="text-wrap">{text}</div>,
    },
    {
      title: "Driver Name",
      dataIndex: "DriverName",
      key: "DriverName",
      ellipsis: false,
      sorter: (a, b) => (a.DriverName || "").localeCompare(b.DriverName || ""),
      sortOrder: tableSort.field === "DriverName" ? tableSort.order : null,
      render: (text) => <div className="text-wrap">{text}</div>,
    },
     {
      title: "KPI Name",
      dataIndex: "NAME",
      key: "NAME",
      ellipsis: false,
      sorter: (a, b) => (a.NAME || "").localeCompare(b.NAME || ""),
      sortOrder: tableSort.field === "NAME" ? tableSort.order : null,
      // render: (text, record) => (
      //   <div style={{ width: "100%", maxWidth: "100%", fontSize: "1rem" }}>
      //     <div style={{ marginBottom: "0.25rem" }}>{text}</div>
      //     <div style={{ fontSize: "0.875rem", color: "#888" }}>
      //       {record.CRON ? new Date(record.CRON).toLocaleString() : "No Cron"}
      //     </div>
      //   </div>
      // ),
    },
    {
      title: "Target Duration",
      dataIndex: "MAXMINUTES",
      key: "MAXMINUTES",
      ellipsis: false,
      sorter: (a, b) => (a.MAXMINUTES || 0) - (b.MAXMINUTES || 0),
      sortOrder: tableSort.field === "MAXMINUTES" ? tableSort.order : null,
      render: (text) => (
        <div style={{ textAlign: "center", lineHeight: 1.5 }}>
          <div>{formattedTime(text)}</div>
          <div style={{ fontSize: "14px", color: "#888" }}>HH:MM</div>
        </div>
      ),
    },

    {
      title: "Actual Duration",
      dataIndex: "DURATION",
      key: "DURATION",
      sorter: (a, b) => (a.DURATION || 0) - (b.DURATION || 0),
      sortOrder: tableSort.field === "DURATION" ? tableSort.order : null,
      render: (text) => (
        <div style={{ textAlign: "center", lineHeight: 1.5 }}>
          <div>{formattedTime(text)}</div>
          <div style={{ fontSize: "14px", color: "#888" }}>HH:MM</div>
        </div>
      ),
    },
    {
      title: "Difference",
      dataIndex: "MINMINUTES",
      key: "MINMINUTES",
      sorter: (a, b) => (a.MINMINUTES || 0) - (b.MINMINUTES || 0),
      sortOrder: tableSort.field === "MINMINUTES" ? tableSort.order : null,
      render: (text) => (
        <div style={{ textAlign: "center", lineHeight: 1.5 }}>
          <div>{formattedDifferentTime(text)}</div>
          <div style={{ fontSize: "14px", color: "#888" }}>HH:MM</div>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => {
        const aResolved = a.RESOLVEDBY != null;
        const bResolved = b.RESOLVEDBY != null;
        return Number(aResolved) - Number(bResolved);
      },
      sortOrder: tableSort.field === "status" ? tableSort.order : null,
      render: (_, record) => {
        const isResolved =
          record.RESOLVEDBY !== null && record.RESOLVEDBY !== undefined;
        const statusText = isResolved ? "Resolved" : "Unresolved";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {!isResolved && <Indicator />} {statusText}
          </div>
        );
      },
    },
    {
      title: "Resolved By",
      dataIndex: "USERS",
      key: "USERS",
      sorter: (a, b) => (a.USERS || "").localeCompare(b.USERS || ""),
      sortOrder: tableSort.field === "USERS" ? tableSort.order : null,
      render: (text) => <div className="text-wrap">{text || "---"}</div>,
    },
    {
      title: "Message",
      dataIndex: "MESSAGE",
      key: "MESSAGE",
      sorter: (a, b) => (a.MESSAGE || "").localeCompare(b.MESSAGE || ""),
      sortOrder: tableSort.field === "MESSAGE" ? tableSort.order : null,
      render: (text) => <div>{text || "---"}</div>,
    },
    {
      title: "#",
      dataIndex: "x",
      key: "x",
      width: 120, // optional fixed width
      render: (text, record) => {
        const isResolved =
          record.RESOLVEDBY !== null && record.RESOLVEDBY !== undefined;
        const isHovered = Hoveredrow === record.key;

        return (
          <div className={`compact-col ${isHovered ? "expanded" : ""}`}>
            {!isHovered ? (
              <span>{text || "---"}</span>
            ) : (
              <>
                <Chat
                  className="cursor-pointer"
                  onClick={() => handleChatClick(record)}
                  style={{ fontSize: 18 }}
                />
                {!isResolved && (
                  <Button
                    style={{
                      cursor: resolveAllowed ? "pointer" : "not-allowed",
                    }}
                    size="small"
                    onClick={() => {
                      if (!resolveAllowed) return;
                      handleresolveopen(record);
                    }}
                    className="resolve_btn"
                  >
                    Resolve
                  </Button>
                )}
              </>
            )}
          </div>
        );
      },
    },
  ];

  const prepareCSV = async (event, done) => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API(
        "POST",
        `kpi/get_Kpialert_Table?MCID=${userInfo?.MCID}&startDate=${dayjs(
          formData?.Daterange?.[0],
        )?.format("YYYY-MM-DD")}&endDate=${dayjs(
          formData?.Daterange?.[1],
        )?.format("YYYY-MM-DD")}&page=${1}&PageSize=${total}`,
        {
          code: formData?.Consigncode || 0,
          RecName: formData?.Consignee || "",
          CustName: formData?.consignor || "",
          Transporter: formData?.Transporter || "",
          DriverName: formData?.Driver || "",
          REGNO: formData?.Vehicle || "",
          Status: formData?.Status || "",
          ConsignId: formData?.ConsignId || "",
          Shipper: formData?.Shipper || 0,
        },
      );
      if (data?.KPIAlertTable.length > 0) {
        // Apply sorting to match table sort order
        const sortedData = applySorting(data?.KPIAlertTable);

        const csvData = (sortedData || []).map((item) => ({
         "Date & Time": item.CRON ? convertUTCToLocal(item.CRON) : "-",
          "Consign Code": item.Code || "-",
          Consignor: item.CustName || "-",
          Transporter: item.Transporter || "-",
          Consignee: item.RecName || "-",
          Driver: item.DriverName || "-",
          "KPI Name": item.NAME || "-",
          Status:
            item.RESOLVEDBY !== null &&
            item.RESOLVEDBY !== undefined &&
            item.RESOLVEDBY !== ""
              ? "Resolved"
              : "UnResolved",
          "Actual Duration (HH:MM)": formattedTime(item.DURATION) || "-",
          "Target Duration (HH:MM)": formattedTime(item.MAXMINUTES) || "-",
          "Difference (HH:MM)": formattedDifferentTime(item.MINMINUTES) || "-",
          "Resolved On": item.RESOLVEDON
            ? moment(item.RESOLVEDON)
                .subtract(3, "hours")
                .format("Do MMM YYYY; hh:mm A")
            : "-",
          "Resolved By": item.USERS || "-",
        }));

        setCSVList(csvData && csvData.length > 0 ? csvData : []);

        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
    } finally {
      setCSVLoader(false);
    }
  };

  const handlemouseenter = (key) => {
    setHoveredRow(key);
  };

  const handlemouseleave = () => {
    setHoveredRow(null);
  };
  const handleclickme = () => {
    SetshowModal(true);
  };

  const handlecancelmodal = () => {
    SetshowModal(false);
  };

  const handleClearFilter = () => {
    form.resetFields();
    SetformData({
      Kpiname: "",
      consignor: "",
      Consignee: "",
      Transporter: "",
      Duration: "current_month",
      Consigncode: "",
      Vehicle: "",
      Driver: "",
      Daterange: [moment().startOf("month"), moment().endOf("month")],
    });
    setFilterCount(0);
  };

  return (
    <>
      <UIModal
        width={600}
        open={resolveModal}
        onClose={handleresolveclose}
        closeButton={false}
        header={
          <Wrappercontainer>
            <Spin spinning={loading}>
              <Row>
                <Col xl={24} sm={24}>
                  <div className="modal_container_forfiltermenu">
                    <h4 className="flilter_five">
                      {modalType === "view" ? "Comments" : "Resolving KPI"}
                    </h4>
                  </div>
                  <hr />
                </Col>

                <Col xl={24} sm={24}>
                  {modalType === "view" ? (
                    <div>
                      <ChatComponent
                        data={commentsList}
                        user={userInfo?.UID}
                        getData={getCommentData}
                        id={389114}
                        RefTab="KPI"
                        setLoading={setLoading}
                      />
                    </div>
                  ) : (
                    <>
                      <strong>Comments</strong>
                      <Input.TextArea
                        placeholder="Enter resolution comments"
                        rows={4}
                        value={selectedRecord?.resolutionComment}
                        onChange={(e) =>
                          setSelectedRecord((prev) => ({
                            ...prev,
                            resolutionComment: e.target.value,
                          }))
                        }
                      />
                    </>
                  )}
                </Col>
              </Row>
            </Spin>
          </Wrappercontainer>
        }
        footer={
          modalType === "resolve" ? (
            <Wrappercontainer>
              <div
                key="footer"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  gap: "15px",
                }}
              >
                <Buttontransparent
                  className="cancel_btn_forpopup_two"
                  onClick={handleresolveclose}
                >
                  Cancel
                </Buttontransparent>
                <ButtonFilled onClick={() => handleResolve()}>
                  Resolve
                </ButtonFilled>
              </div>
            </Wrappercontainer>
          ) : null
        }
      />

      <Wrappercontainer>
        <Row>
          <Col xl={24} sm={24}>
            <Spin spinning={loading}>
              <div>
                <div className="customizable_container_forkpi">
                  <div className="customizable_container">
                    <p className="kpialerts">KPI Alerts</p>
                    <p>{kpiReportData?.data?.KPIAlert?.[0]?.Total ?? 0}</p>
                  </div>
                  <div className="customizable_container">
                    <p className="Resolved">Resolved</p>
                    <p>{kpiReportData?.data?.KPIAlert?.[0]?.Resolved ?? 0}</p>
                  </div>
                  <div className="customizable_container">
                    <p className="UnResolved">UnResolved</p>
                    <p>{kpiReportData?.data?.KPIAlert?.[0]?.Unresolved ?? 0}</p>
                  </div>
                </div>
              </div>
            </Spin>
          </Col>
        </Row>
      </Wrappercontainer>

      <Wrappercontainer>
        <Row gutter={16} className="container_two_fordropdown mx-4">
          <Col xl={14} sm={24}>
            <p>KPI Alerts</p>
          </Col>

          <Col xl={10} sm={24}>
            <div className="d-flex justify-content-end gap-3 align-items-center">
              <Spin spinning={CSVLoader}>
                <ImportIcon
                  className="mx-2"
                  onClick={() => {
                    if (!exportAllowed) return;
                    prepareCSV();
                  }}
                  style={{ cursor: exportAllowed ? "pointer" : "not-allowed" }}
                />
              </Spin>
              <CSVLink
                data={CSVList && CSVList.length > 0 ? CSVList : []}
                filename={"KPI Report.csv"}
                asyncOnClick={true}
                ref={csvLinkEl}
              />
              <Badge count={filterCount} onClick={handleclickme}>
                <div className="Iconbg">
                  <img src={FilterIcon} alt="Filter Icon" width={20} />
                </div>
              </Badge>
              <Tooltip title={!resolveAllowed ? "No permission" : ""}>
                <ButtonFilled
                  style={{
                    cursor: resolveAllowed ? "pointer" : "not-allowed",
                  }}
                  onClick={() => {
                    if (!resolveAllowed) return;
                    handleBulkResolve(unresolvedKPIs);
                  }}
                >
                  Resolve All
                </ButtonFilled>
              </Tooltip>
            </div>
          </Col>

          <UIModal
            width={1200}
            open={showModal}
            onClose={handlecancelmodal}
            closeButton={false}
            size="lg"
            header={
              <Wrappercontainer>
                <Row>
                  <Col xl={24} sm={24}>
                    <div className="modal_container_forfiltermenu">
                      <span className="flilter_five">
                        Filters ({filterCount})
                      </span>
                      <span>({filterCount}) Results Found</span>
                    </div>
                  </Col>
                </Row>
              </Wrappercontainer>
            }
            footer={[
              <Wrappercontainer>
                <div
                  key="footer"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    gap: "15px",
                  }}
                >
                  <ButtonFilled onClick={handleClearFilter}>
                    Clear All
                  </ButtonFilled>
                </div>
              </Wrappercontainer>,
            ]}
          >
            <KpireportFilter
              SetformData={SetformData}
              formData={formData}
              filterCount={filterCount}
              setFilterCount={setFilterCount}
              form={form}
              setFilterData={setFilterData}
              filterData={filterData}
            />
          </UIModal>

          <Col xl={24} sm={24}>
            <Spin spinning={loading}>
              {kpiReporttabledata.length > 0 && (
                <StyledTable
                  dataSource={kpiReporttabledata}
                  rowClassName={() => "custom-row"}
                  pagination={false}
                  columns={columns}
                  onChange={(pagination, filters, sorter) => {
                    setTableSort({
                      field: sorter.field,
                      order: sorter.order,
                    });
                  }}
                  onRow={(record, index) => ({
                    onMouseEnter: () => {
                      handlemouseenter(record?.key);
                    },
                    onMouseLeave: () => {
                      handlemouseleave();
                    },
                  })}
                />
              )}
              <ReusablePagination
                pageSize={PageSize}
                handlePageSizeChange={handlePageSizeChange}
                currentPage={currentPage}
                total={total}
                handlePageChange={handlePageChange}
              />
            </Spin>
          </Col>
        </Row>
      </Wrappercontainer>
    </>
  );
};

const KpireportFilter = ({
  filterData,
  formData,
  SetformData,
  filterCount,
  setFilterCount,
  setFilterData,
}) => {
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const driverList = useSelector((state) => state?.authTracking?.driverList);

  const [form] = Form.useForm();
  const duration = Form.useWatch("Duration", form); // Watch 'Duration' field

  useEffect(() => {
    if (!duration || duration === "---") {
      // Reset daterange if duration is cleared
      form.setFieldValue("Daterange", undefined);
      setFilterData((prevValue) => ({ ...prevValue, Daterange: undefined }));
      SetformData((prevValue) => ({ ...prevValue, Daterange: undefined }));
      return;
    }

    let start, end;
    if (duration === "last_month") {
      start = dayjs().subtract(1, "month").startOf("month");
      end = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_month") {
      start = dayjs().startOf("month");
      end = dayjs().endOf("month");
    } else if (duration === "current_year") {
      start = dayjs().startOf("year");
      end = dayjs().endOf("year");
    } else if (duration === "today") {
      const today = dayjs();
      start = today;
      end = today;
    }

    if (start && end) {
      form.setFieldValue("Daterange", [start, end]);
      setFilterData((prevValue) => ({ ...prevValue, Daterange: [start, end] }));
      SetformData((prevValue) => ({ ...prevValue, Daterange: [start, end] }));
    }
  }, [duration]); // Include form and state setters in dependency array

  const handleChange = (e) => {
    const { name, value } = e.target;
    SetformData((PrevValue) => ({ ...PrevValue, [name]: value }));
  };

  const handleFilterSelectChange = (field, value) => {
    SetformData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };

  useEffect(() => {
    const count1 = Object.values(formData).filter((val) => val);
    const count = Object.values(formData).filter(
      (val) => val && val?.length !== 0,
    ).length;
    setFilterCount(count);
  }, [formData, filterCount]);

  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
    { label: "---", value: "---" },
  ];

  const addeditform = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [
          [6, 6, 6, 6],
          [6, 6, 6, 6],
          [6, 6],
          [6, 6, 6, 6],
        ],
        fields: [
          [
            {
              name: "Kpiname",
              label: "KPI Name",
              type: "text",
              placeholder: "Custifield Kpi",
              value: formData.Kpiname,

              style: "",
              validationRules: [
                {
                  message: "Kpiname must be a valid ",
                },
              ],
            },
            {
              name: "consignor",
              label: "Consignor",
              type: "selectwithvalue",

              options: consignerList?.map((item) => ({
                label: item.Name,
                value: item.Name,
              })),
            },
            {
              name: "Consignee",
              label: "Consignee",
              type: "selectwithvalue",

              options: consigneeList?.map((item) => ({
                label: item.Name,
                value: item.Name,
              })),
            },
            {
              name: "Transporter",
              label: "Transporter",
              type: "selectwithvalue",
              value: formData.Transporter,

              options: transporterList?.map((item) => ({
                label: item.Name,
                value: item.Name,
              })),
            },
          ],
          [
            {
              name: "Duration",
              label: "Duration",
              type: "selectwithvalue",

              value: formData.Duration,
              options: Duration?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              label: "Date Range",
              name: "Daterange",
              type: "daterange",
              placeholder: ["Start Date", "End Date"],
            },
            {
              name: "Consigncode",
              label: "Consign Code",
              type: "text",
              value: formData.Consigncode,

              style: "",
              validationRules: [
                {
                  message: "Consign Code must be a valid ",
                },
              ],
            },
            {
              name: "Vehicle",
              label: "Vehicle",
              type: "selectwithvalue",
              value: formData.Vehicle,

              options: vehicleList?.map((item) => ({
                label: item.REGNO,
                value: item.REGNO,
              })),
            },
          ],
          [
            {
              name: "Driver",
              label: "Driver",
              type: "selectwithvalue",
              value: formData.Driver,
              options: driverList?.map((item) => ({
                label: item.FULLNM,
                value: item.FULLNM,
              })),
            },
            {},
            {},
            {},
          ],
        ],
      },
    ],
  };

  const handleSubmit = (values) => {
    // Your form submission logic here
  };

  return (
    <Row>
      <Col xl={24} sm={24}>
        <GridBuilder
          handleChange={handleChange}
          formSubmit={handleSubmit}
          formStructureJson={addeditform}
          initialValues={formData}
          form={form}
          handleSelectChange={handleFilterSelectChange}
        />
      </Col>
    </Row>
  );
};
export { Kpireport, KpireportFilter };
